const BanestesValidatorRules = {

  changeAgency: agency => {
    return agency.substr(agency.length - 2)
  },

  pesos11: [2, 3, 4, 5, 6, 7, 8, 2, 3, 4, 5, 6, 7, 8, 2, 3, 4],

  pesos10: [2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1, 2.2, 1]
}

const BanestesValidator = {

  agencyNumberIsValid: function(agencyNumber) {
    return !(agencyNumber == "" || agencyNumber == undefined)
  },

  agencyCheckNumberIsValid: function(agencyCheckNumber) {
    return true
  },

  accountNumberIsValid: function(accountNumber) {
    return ((accountNumber || "").length === this.accountNumberLength()) && (/^[0-9]{1,12}$/.test(accountNumber)) && (parseInt(accountNumber) > 0)
  },

  accountCheckNumberIsValid: function(accountCheckNumber) {
    return !(accountCheckNumber == "" || accountCheckNumber == undefined)
  },

  agencyCheckNumberMatch: function(bankAccount) {
    return true;
  },

  accountCheckNumberMatch: function(bankAccount) {
    let digit = parseInt(bankAccount.accountCheckNumber)

    let mod = (bankAccount.accountNumber.substr(0, 3) == "000") ? 10 : 11
    let peso = mod == 10 ? BanestesValidatorRules.pesos10 : BanestesValidatorRules.pesos11

    let arrNumbers = mod == 10 ? bankAccount.accountNumber.split('') : ('0' + bankAccount.accountNumber).split('')

    let soma = arrNumbers.reverse()
    .map((n, index) => parseInt(parseInt(n) * peso[index]))
    .reduce((soma, number) => soma + number, 0)

    let resto = soma % mod

    if(resto == 1 || resto == 0) return digit === 0
    return digit == mod - resto
  },

  agencyNumberMsgError: function() {
    return "Agência inválida";
  },

  agencyCheckNumberMsgError: function() {
    return "Dígito da agência inválido";
  },

  accountNumberMsgError: function(length) {
    return "A conta corrente deve conter " + length + " números. Complete com zeros a esquerda se necessário.";
  },

  accountNumberLength: function() { return 9; }

};

module.exports = BanestesValidator;



// WEBPACK FOOTER //
// ./src/assets/js/arautos-bank-validator/banco-estado-espirito-santo.js